import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react'

export const ConfirmActionModal = ({ isOpen, onClose, onConfirm }) => {
    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose} size='xs'>
            <ModalOverlay />
            <ModalContent bg="background" color="text">
                <ModalHeader>Are you Sure?</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Box display="flex" flexDir="column" justifyContent="center" alignItems="center">
                        Are you sure you want to delete this session?
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button variant='outline' onClick={onClose} mr={3}>Cancel</Button>
                    <Button onClick={onConfirm}>Delete</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
